module.exports = __webpack_public_path__ + "img/wzjs3.69e01331.jpg";